// eslint-disable-next-line @typescript-eslint/ban-types
function hasOwnProperty(obj, prop) {
    // eslint-disable-next-line no-prototype-builtins
    return obj.hasOwnProperty(prop);
}
export default hasOwnProperty;
